import { translate } from "app/filters/i18nFilter";
import { createPrimitiveListCellValue, ListCell } from "app/pages/sales-intelligence/common-components/table-cells";
import type { IBaseAppsRowDto } from "app/pages/sales-intelligence/modules/apps-search/types/rows";
import appsSearchI18nKeys from "app/pages/sales-intelligence/modules/apps-search/utils/i18n";

type Props = { value: NonNullable<IBaseAppsRowDto["business_models"]> };

const BusinessModelsCell = ({ value }: Props) => {
    const translatedValues = value?.map((item) => translate(appsSearchI18nKeys.cell.businessModelsLabel(item)));

    return (
        <ListCell
            value={translatedValues}
            dataAutomation="app-business-models"
        >
            {createPrimitiveListCellValue({ value: translatedValues })}
        </ListCell>
    );
};

export default BusinessModelsCell;
